import { getDefaultMargin, getDefaultMarginOverlay, getDefaultWidthOverlay } from '../utils'

export const TableDesignSettings = {
  // Dimension
  'table-design-width': {
    phone: ['100%'],
    'phone-landscape': ['100%'],
    tablet: ['100%'],
    'tablet-landscape': ['100%'],
    desktop: ['50%'],
    tv: ['50%'],
    overflowSetting: getDefaultWidthOverlay,
  },
  'table-design-search-width': {
    phone: ['100%'],
    'phone-landscape': ['100%'],
    tablet: ['100%'],
    'tablet-landscape': ['100%'],
    desktop: ['100%'],
    tv: ['100%'],
  },
  // Alignment
  'table-design-comp-h-align': {
    phone: 'parent',
    'phone-landscape': 'parent',
    tablet: 'parent',
    'tablet-landscape': 'parent',
    desktop: 'parent',
    tv: 'parent',
  },
  'table-design-title-h-align': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  'table-design-footer-h-align': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  'table-design-pagination-h-align': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  'table-design-search-alignment': {
    phone: 'start',
    'phone-landscape': 'start',
    tablet: 'start',
    'tablet-landscape': 'start',
    desktop: 'start',
    tv: 'start',
  },
  // Typography
  'table-design-typography': {
    'table-design-title-typography': {
      phone: { typography: 'Title Large' },
      'phone-landscape': { typography: 'Title Large' },
      tablet: { typography: 'Title Large' },
      'tablet-landscape': { typography: 'Title Large' },
      desktop: { typography: 'Title Large' },
      tv: { typography: 'Title Large' },
    },
    'table-design-row-header-typography': {
      phone: { typography: 'Body Large' },
      'phone-landscape': { typography: 'Body Large' },
      tablet: { typography: 'Body Large' },
      'tablet-landscape': { typography: 'Body Large' },
      desktop: { typography: 'Body Large' },
      tv: { typography: 'Body Large' },
    },
    'table-design-row-item-typography': {
      phone: { typography: 'Body Medium' },
      'phone-landscape': { typography: 'Body Medium' },
      tablet: { typography: 'Body Medium' },
      'tablet-landscape': { typography: 'Body Medium' },
      desktop: { typography: 'Body Medium' },
      tv: { typography: 'Body Medium' },
    },
    'table-design-footer-typography': {
      phone: { typography: 'Body Medium' },
      'phone-landscape': { typography: 'Body Medium' },
      tablet: { typography: 'Body Medium' },
      'tablet-landscape': { typography: 'Body Medium' },
      desktop: { typography: 'Body Medium' },
      tv: { typography: 'Body Medium' },
    },
  },
  // Spacing
  'table-design-title-margin': {
    phone: getDefaultMargin([0]),
    'phone-landscape': getDefaultMargin([0]),
    tablet: getDefaultMargin([0]),
    'tablet-landscape': getDefaultMargin([0]),
    desktop: getDefaultMargin([0]),
    tv: getDefaultMargin([0]),
  },
  'table-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
    overflowSetting: getDefaultMarginOverlay,
  },
  'table-design-padding': {
    phone: getDefaultMargin([16]),
    'phone-landscape': getDefaultMargin([16]),
    tablet: getDefaultMargin([16]),
    'tablet-landscape': getDefaultMargin([16]),
    desktop: getDefaultMargin([16]),
    tv: getDefaultMargin([16]),
  },
  'table-design-search-margin': {
    phone: getDefaultMargin([0, 0, 12]),
    'phone-landscape': getDefaultMargin([0, 0, 12]),
    tablet: getDefaultMargin([0, 0, 12]),
    'tablet-landscape': getDefaultMargin([0, 0, 12]),
    desktop: getDefaultMargin([0, 0, 12]),
    tv: getDefaultMargin([0, 0, 12]),
  },
  'table-design-filter-margin': {
    phone: getDefaultMargin([0, 0, 12]),
    'phone-landscape': getDefaultMargin([0, 0, 12]),
    tablet: getDefaultMargin([0, 0, 12]),
    'tablet-landscape': getDefaultMargin([0, 0, 12]),
    desktop: getDefaultMargin([0, 0, 12]),
    tv: getDefaultMargin([0, 0, 12]),
  },
}
